export const DataType = {
  String: "string",
  Image: "image",
  Video: "video",
  Audio: "audio",
  Number: "number",
  Boolean: "boolean",
  File: "file",
  Json: "json",
  Trigger: "trigger",
  Media: "media",
} as const

export type DataType = (typeof DataType)[keyof typeof DataType]

export interface ModuleInput {
  name: string
  type: DataType
  required: boolean
  /** true = connectable port on the node, false = config field in inspector */
  handle: boolean
  description: string
  config?: {
    default?: unknown
    min?: number
    max?: number
    choices?: string[]
    multiline?: boolean
  }
}

export interface ModuleOutput {
  name: string
  type: DataType
  handle: boolean
  description: string
}

export type ModuleCategory =
  | "input"
  | "generation"
  | "transform"
  | "output"
  | "utility"
  | "control"
  | "agent"

export type ModelCategory = "text" | "image" | "video" | "audio" | "music"

export interface ModuleDefinition {
  /** Unique key: "image_gen", "llm_text", etc. */
  module: string
  title: string
  category: ModuleCategory
  description: string
  /** Icon identifier — mapped to HugeIcons component in the UI */
  icon: string
  supportedProviders: string[]
  inputs: ModuleInput[]
  outputs: ModuleOutput[]
  /** Present on AI generation modules — drives the unified model selector */
  modelConfig?: {
    categories: ModelCategory[]
  }
}
